/* =============================================================================
=    Login
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
mutation login($email: String!, $password: String!, $gaCookies: String!) {
  login(email: $email, password: $password, gaCookies: $gaCookies) {
    id
  }
}
`;
